/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["body[_ngcontent-%COMP%], html[_ngcontent-%COMP%]{padding:0;border:0 solid #b0c4de;border-radius:10px;overflow-y:auto;margin:0 auto;height:92vh}*[_ngcontent-%COMP%]{box-sizing:border-box}.container[_ngcontent-%COMP%]{margin:0;padding:0;font-size:20px}.first_page[_ngcontent-%COMP%], .im[_ngcontent-%COMP%]{border-radius:10px;overflow-y:auto;margin:0 auto}.im[_ngcontent-%COMP%]{height:30vh;width:90vw}.image[_ngcontent-%COMP%]{height:20vh;overflow-y:auto}.footer[_ngcontent-%COMP%], .image[_ngcontent-%COMP%]{width:95vw;margin:0 auto}.footer[_ngcontent-%COMP%]{height:35vh;padding:0}"];
export { styles as styles };

